const initialState = {
	isLoading: false,
	list: [],
	totalsize: 0,
	list_shop: [],
};

function cancelOrdersReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOADING_CANCEL_ORDER':
			return {
				...state,
				isLoading: action?.payload
			};
		case 'ADMIN_LIST_CANCEL_ORDER':
			return {
				...state,
				list: action?.payload?.cancelOrders || [],
				totalsize: action?.payload?.totalsize || 0,
				list_shop: action?.payload?.list_shop || [],
			};
		default:
			return state;
	}
}

export default cancelOrdersReducer;
